var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w1200 f16 lin-30" },
    [
      _c("p", { staticClass: "text-center f30 pad40-tb" }, [
        _vm._v("代付说明")
      ]),
      _c("p", [
        _c("span", { staticClass: "text-indent" }, [_vm._v("本人/单位")]),
        _vm._v(
          "【 " +
            _vm._s(_vm.contInfo.contract1) +
            " 】 （身份证号/统一社会信用代码：【 " +
            _vm._s(_vm.contInfo.contract2) +
            " 】） 不可撤销地同意就【\n    " +
            _vm._s(_vm.contInfo.contract3) +
            " 】（身份证号/统一社会信用代码：【 " +
            _vm._s(_vm.contInfo.contract4) +
            " 】）\n    在农信商城（网址：nxinstore.com）上的发生的交易代其向卖家支付订单金额【 " +
            _vm._s(_vm.contInfo.contract5) +
            " 】元 。\n  "
        )
      ]),
      _c("p", [
        _c("span", { staticClass: "text-indent" }, [_vm._v("对应交易单号：")]),
        _vm._v("【 " + _vm._s(_vm.contInfo.contract6) + " 】。")
      ]),
      _c("p", [
        _c("span", { staticClass: "text-indent" }, [_vm._v("卖家")]),
        _vm._v(
          "【 " +
            _vm._s(_vm.contInfo.contract7) +
            " 】（身份证/统一社会信用代码：【 " +
            _vm._s(_vm.contInfo.contract8) +
            " 】）。"
        )
      ]),
      _c("p", { staticClass: "text-indent-title fb" }, [
        _vm._v("本人/单位确认:")
      ]),
      _c("p", { staticClass: "fb text-indent" }, [
        _vm._v(
          "（1）一经点击同意代付，将上述款项支付至卖家账户，即为完成代付，本人/单位将不得以任何理由撤销代付;"
        )
      ]),
      _c("p", { staticClass: "fb text-indent" }, [
        _vm._v(
          "\n    （2）上述代付行为为本人/单位真实的意思表示，本人/单位已清楚知悉上述代付行为所代表的含义与法律责任，并自愿承担由此产生的一切责任;\n  "
        )
      ]),
      _c("p", { staticClass: "fb text-indent" }, [
        _vm._v(
          "（3）因上述代付行为产生的任何纠纷，由本人/单位自行解决，与平台无关。"
        )
      ]),
      _c("p", { staticClass: "text-indent" }, [
        _vm._v(
          "本人/单位确认已知悉上述所有内容（特别是加粗字体内容）的意义以及由此产生的法律效力，自愿作出上述代付行为。"
        )
      ]),
      _c("p", { staticClass: "text-indent" }, [
        _vm._v(
          "\n    本人/单位同意本代付说明文件使用杭州尚尚签网络科技有限公司提供的上上签电子签约平台服务通过电子签名以数据电文形式订立，具体出具数字证书的电子认证服务机构（CA,\n    Certificate Authority）以实际签署时为准，一经本人/单位单方签署即发生法律效力；\n  "
        )
      ]),
      _c("p", { staticClass: "text-indent" }, [
        _vm._v(
          "\n    本人/单位同意在平台方及杭州尚尚签网络科技有限公司或其合作第三方的服务器上以电子形式保存本文件。本文件经本人/单位通过上述方式签署并于平台系统记录的签约之日起发生法律效力\n  "
        )
      ]),
      _c(
        "div",
        { staticClass: "text-center pad40-tb" },
        [
          _vm.basicCaAgreementUrl
            ? _c(
                "div",
                { staticClass: "mar20-b" },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.isSign },
                      on: { change: _vm.onBasicCaCheckedChange },
                      model: {
                        value: _vm.basicCaChecked,
                        callback: function($$v) {
                          _vm.basicCaChecked = $$v
                        },
                        expression: "basicCaChecked"
                      }
                    },
                    [
                      _vm._v("\n        我已阅读并同意"),
                      _c(
                        "span",
                        {
                          staticClass: "red pointer",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.openBasicCaAgreement($event)
                            }
                          }
                        },
                        [_vm._v("《" + _vm._s(_vm.basicCaAgreementName) + "》")]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.isSign },
              on: { click: _vm.sign }
            },
            [_vm._v("我已阅读并同意签署")]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "basic-ca-auth-file-dialog",
          attrs: {
            title: "重要事项提醒",
            visible: _vm.basicCaAuthFileDialogVisible,
            width: "520px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "show-close": false,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.basicCaAuthFileDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "basic-ca-auth-file-content" }, [
            _c("p", [_vm._v("1、请打印《企业授权书》并盖章，提供PDF或图片")]),
            _c("p", [
              _vm._v("2、请保证授权书中"),
              _c("span", { staticClass: "red" }, [
                _vm._v("被授权人与当前操作人")
              ]),
              _vm._v("保持一致以免认证失败")
            ]),
            _c(
              "a",
              {
                staticClass: "basic-ca-auth-file-download",
                attrs: {
                  href: _vm.basicCaAuthFileTemplateUrl,
                  target: "_blank"
                }
              },
              [_vm._v("点击下载《企业授权书》模版")]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "basic-ca-auth-file-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium", type: "danger" },
                  on: { click: _vm.onBasicCaAuthFileReady }
                },
                [_vm._v("已准备好")]
              ),
              _c("div", { staticClass: "mar10-t" }, [
                _c(
                  "a",
                  {
                    staticClass: "red",
                    attrs: { href: "javascript:;" },
                    on: { click: _vm.onBasicCaAuthFileCancel }
                  },
                  [_vm._v("取消")]
                )
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }